import { Component } from 'preact'
import Tooltip from '../ui-components/Tooltip'

class IdeationListItem extends Component {
  render (props, state) {
    const item = props.item
    const statusStyle = {
      background: item.bgColor,
      color: item.textColor
    }
    return (
      <tr className='ideation-list__table-body-item' id={`id-${props.item.id}`}>
        <td className='ideation-list__table-body-item-status'>
          <span style={statusStyle} className='ideation-list__table-body-item-status-name'>{ item.name }</span>
          {
            item.default ? (
              <span className='ideation-list__table-body-item-status-default'>
                Default
                <Tooltip
                  trigger={<i className='fa fa-question-circle' />}
                  tooltipMessage={'Default status will be automatically assigned when a new idea is created'}
                />
              </span>
            ) : null
          }
        </td>
        <td className='ideation-list__table-body-item-backgorund'>
          <div className='ideation-list__table-body-item-color-container'>
            <span style={{ backgroundColor: item.bgColor }} className='ideation-list__table-body-item-color ideation-color-preview' />
            <span>{item.bgColor}</span>
          </div>
        </td>
        <td className='ideation-list__table-body-item-text'>
          <div className='ideation-list__table-body-item-color-container'>
            <span style={{ backgroundColor: item.textColor }} className='ideation-list__table-body-item-color ideation-color-preview' />
            <span>{item.textColor}</span>
          </div>
        </td>
        <td>
          <div className={'btn btn-default'} onClick={() => props.openEditIdeationModal(item, props.idx)} data-action='edit'>Edit</div>
          {
            !item.default ? (
              <div className={'btn btn-danger'} onClick={() => props.deleteCallback(props.idx)} data-action='delete'>Delete</div>
            ) : null
          }
        </td>
      </tr>
    )
  }
}

export default IdeationListItem
